module.exports = __webpack_public_path__ + "img/02b_marketing.360eb320.jpg";